export default "__VITE_PUBLIC_ASSET__d70be19a__"